import { UpdateContractResponseContent } from '@/types/contract.types';
import { createApiRequest } from "../common";

export const updateContractApi = async (contractId: string, name: string): Promise<UpdateContractResponseContent> => {
  const request = createApiRequest<UpdateContractResponseContent>('post', '/updateContract');
  return request({ contractId, name });
};